<template>
  <div class="type-of-review wrap-content">
    <div class="wrap-inner">
      <div class="wrap-form">
        <label class="form-label" style="margin-bottom:20px">评阅类型设置</label>
        <span>学生类型：</span>
        <Select v-model="stuType" @on-change="fetchMaterialConfig(stuType)" style="width:200px">
          <Option v-for="item in stuTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <div v-for="(item,index) in typeList" :key="index" class="wrap-form-item">
          <Checkbox v-model="item.checked" :disabled="index==0">{{item.label}}</Checkbox>
        </div>
        <Button type="primary" @click="flag && saveConfig()" style="margin-top:20px">保存配置</Button>
      </div>
    </div>
  </div>
</template>

<script>
// 评阅类型配置
export default {
  name: 'typeOfReview',
  data () {
    return {
      stuType: '',
      flag: true,
      stuTypeList: [
      ],
      typeList: [
        {
          value: 'originalPaperNeed',
          label: '论文原文',
          checked: true
        },
        {
          value: 'summaryNeed',
          label: '论文摘要',
          checked: false
        },
        {
          value: 'profileTableNeed',
          label: '论文简况表',
          checked: false
        },
        {
          value: 'selfTableNeed',
          label: '论文自评表',
          checked: false
        }
      ]
    }
  },
  created () {
    this.getDegreeTpe()
  },
  activated () {
    this.getDegreeTpe()
  },
  methods: {
    // fetchMaterialConfig () {
    //   this.post('/school/schoolMaterialConfig/getSchoolMaterialConfig').then(res => {
    //     for (let type of this.typeList) {
    //       type.checked = res.data[type.value];
    //     }
    //   });
    // },
    async getDegreeTpe () {
      let url = '/conf/confDegreeType/queryDegreeTypeList'
      let res = await this.post(url)
      if (res.code === 200) {
        this.stuTypeList = res.data
        this.stuType = res.data[0].id
        this.fetchMaterialConfig(res.data[0].id)
      }
    },
    fetchMaterialConfig (type) {
      this.fetch('/school/schoolMaterialConfig/getSchoolMaterialConfig', {degreeType: type}).then(res => {
        if (res.data) {
          for (let type of this.typeList) {
            type.checked = res.data[type.value] === '1';
          }
          this.typeList[0].checked = true;
        } else {
          this.typeList[1].checked = false;
          this.typeList[2].checked = false;
          this.typeList[3].checked = false;
        }
      });
    },
    saveConfig () {
      this.flag = false
      if (this.stuType === '') {
        this.$Message.error('请选择学生类型');
      } else {
        let param = {
          degreeType: this.stuType
        };
        for (let type of this.typeList) {
          param[type.value] = type.checked ? '1' : '0'
        }
        this.post('/school/schoolMaterialConfig/saveSchoolMaterialConfig', param).then(res => {
          if (res.code === 200) {
            this.$Message.success('保存成功！');
          }
        })
      }
      let _self = this
      setInterval(function () {
        _self.flag = true
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
  .type-of-review{
    .wrap-form-item {
      height: 32px;
      line-height: 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/customPage/configManage/typeOfReview.vue